const staticContent = ['Ja', 'Nein', 'Vielleicht, abhängig vom Angebot'];
module.exports = staticContent;
